interface ArrowRightIconProps {
	className?: string;
}

export function ArrowRightIcon({ className }: ArrowRightIconProps) {
	return (
		<svg
			width="14"
			height="9"
			viewBox="0 0 14 9"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			aria-hidden="true"
		>
			<path
				d="M0.694336 4.02779H12.361M12.361 4.02779L9.02767 7.36112M12.361 4.02779L9.02767 0.694458"
				stroke="currentColor"
				strokeWidth="1.38889"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
